export var valuesEmailKnown = ["None", "PPX", "PPN"];
/*

*/ 
//# sourceMappingURL=EmailKnown.js.map